/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Media_TypeInputs */



/**
* | output |
* | --- |
* | "Media Type" |
*
* @param {Media_TypeInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const media_type = /** @type {((inputs?: Media_TypeInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Media_TypeInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Type de média")
	if (locale === "de") return /** @type {LocalizedString} */ ("Medientyp")
	if (locale === "it") return /** @type {LocalizedString} */ ("Tipo di supporto")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Тип носителя")
	if (locale === "es") return /** @type {LocalizedString} */ ("Tipo de medio")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("媒体类型")
	if (locale === "ja") return /** @type {LocalizedString} */ ("メディアタイプ")
	if (locale === "hi") return /** @type {LocalizedString} */ ("मीडिया प्रकार")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Tipo de mídia")
	return /** @type {LocalizedString} */ ("Media Type")
});